<div class="claim-detail-sec">
  <div class="claim-item">
    <div class="claim-number">
      <ng-container
        *ngIf="claim?.propertyOrAutoIndicator === 'AUTO'  else homeLogo"
      >
        <img src="./assets/img/images/icon-car.svg" class="claim-document-icon" alt="car icon" />
      </ng-container>
      <ng-template #homeLogo>
        <ng-container *ngIf="isAcmic; else maHomeIcon">
          <ng-container  *ngIf="claim?.propertyOrAutoIndicator === 'UMBRELLA'; else acmicHomeIcon" >
            <img src="./assets/img/images/icon-umbrella.svg" alt="umbrella icon" class="claim-document-icon" />
          </ng-container>
          <ng-template #acmicHomeIcon>
            <img src="./assets/img/images/icon-home.svg" alt="home icon" class="claim-document-icon" />
          </ng-template>
        </ng-container>
        <ng-template #maHomeIcon>
          <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'HOME'; else otherPolicyIcon">
            <img src="./assets/img/images/icon-home.svg" alt="home icon" />
          </ng-container>
          <ng-template #otherPolicyIcon>
            <div class="{{ claim?.propertyOrAutoIndicator | lowercase }}-class paperless-bg margin-right mr8 width-40 height-40"
              *ngIf="claim?.propertyOrAutoIndicator!=='AUTO' && claim?.propertyOrAutoIndicator !== 'HOME' "></div>
          </ng-template>
        </ng-template>
      </ng-template>
      <div class="claims-font ml-8">{{ claimid }}</div>
    </div>
    <div class="claim-info">
      <div class="claim-info-left">
        <div>{{ claim?.lossCause }}</div>
        <div class="policy-id margin-bottom mb4 claim-infor-color">
           <ng-container>
              <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' || claim?.propertyOrAutoIndicator === 'HOME'">Personal</ng-container>
              {{claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' ? 'auto' : claim?.propertyOrAutoIndicator === 'HOME' ? 'property' : claim?.propertyOrAutoIndicator | translate | titlecase }} - {{ claim?.policyNumber?.policyNumber }}
            </ng-container>
        </div>
        <div class="date-loss">
          <span> {{ "Date of loss" | translate }}:</span>
          {{ claim?.date | date: "MM/dd/yyyy" }}
        </div>
      </div>
    </div>
  </div>
  <app-cliams-nav [claimId]="claimid"></app-cliams-nav>
</div>
<div class="claim-detail-exposures claim-detail-sections">
  <ng-container *ngIf="documents?.length; else noClaimDocuments">
    <section class="claim-details-left">
      <div class="exposures-content">
        <div class="exposures-title mb-3">
          {{ "Claim documents" | translate }}
        </div>
        <div class="no-exposures-info">
          <table class="table sclaimsTbl claims-table claim-doc-table">
            <tbody class="fake-black-color">
              <ng-container *ngFor="let doc of documents; index as i">
                <tr class="row-content border-full grey-border" [ngClass]="{ 'fnol-doc': doc.name === 'OnlineClaimSubmission.pdf' }">
                  <td class="fw-300 claim-table-font">
                    {{ doc.transactionDate | date: "MM/dd/yyyy" }}
                  </td>
                  <td class="cp-blue merge-in-one claim-table-font fw-500">
                    {{ doc.name }}
                  </td>
                  <td class="merge-in-one fw-300 claim-table-font">
                    {{ doc.description }}
                  </td>
                  <td>
                    <div                      
                      class="align-top cp-download"
                    >
                      <span class="d-flex">
                        <span (click)="
                        onViewDocument(
                          claim.policyNumber.policyNumber,
                          doc.documentId,
                          claimid,
                          doc.type,
                          doc.transactionDate,
                          i+1
                        )
                      " class="mr-1 cursor-pointer ele-custom-loader view-doc-action-{{i+1}} claim-table-font fw-500">{{ "View" | translate }}</span>
                        <span (click)="
                        onDownloadDocument(
                        claim.policyNumber.policyNumber,
                        doc.documentId,
                        claimid,
                        doc.type,
                        doc.transactionDate,
                        i+1
                      )
                    " class="claims-download-icon cursor-pointer ele-custom-loader download-doc-action-{{i+1}}" >
                        <ng-container *ngIf="isAcmic; else maState">
                            <img src="./assets/img/images/icon-download-red.svg" alt="download icon" />
                        </ng-container>
                        <ng-template #maState>
                           <ng-container *ngIf="doc.name === 'OnlineClaimSubmission.pdf'; else nonFNOL">
                              <img src="./assets/img/images/icon-download-white.svg" alt="download icon" />
                           </ng-container>
                           <ng-template #nonFNOL>
                              <img src="./assets/img/images/icon-download-red.svg" alt="download icon" />
                           </ng-template>
                            
                        </ng-template>  
                      </span>                      
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <section class="claim-details-right">
      <div class="row claims-faq mb-4">
        <div class="col">
          <app-upload-documents-sidebar
            [claimId]="claimid"
          ></app-upload-documents-sidebar>
        </div>
      </div>
      <div class="row claims-faq mb-4" *ngIf="!isAcmic">
        <div class="col">
          <app-claims-need-help></app-claims-need-help>
        </div>
      </div>
    </section>
  </ng-container>
  <ng-template #noClaimDocuments>
    <section class="claim-details-left no-right-bdr">
      <div class="exposures-content">
        <div class="exposures-title mb-3">
          {{ "Claim documents" | translate }}
        </div>

        <div class="claim-doc-upload-adjuster">
          <div class="claim-doc-title mt-5 mb-5">
            {{ "You haven't uploaded any documents." | translate }}
          </div>
          <img src="./assets/img/images/icon-claim-documents.svg" alt="claim documents" />
          <div class="mb-2 mt-4 para">
            {{
              "Upload important claim documents for your adjuster." | translate
            }}
          </div>
          <mapfre-button
            [routerLink]="['/claims/' + claimid + '/upload-documents']"
            additionalClasses="ghost primary a-h24 x-small-btn sendDocBtn"
          >
            {{ "Upload documents" }}
          </mapfre-button>
        </div>
      </div>
    </section>
  </ng-template>
</div>
